<div class="form-group">
  <label [class.success]="showSuccess" [for]="inputName" class="input-label"
    >{{ labelName }} <span *ngIf="flagAsRequired">*</span></label
  >
  <div class="input-group mb-3">
    <input
      #typeahead
      (focus)="onFocus()"
      (selectItem)="onItemSelected($event)"
      [editable]="editable"
      [formControlName]="inputName"
      [formControlName]="inputName"
      [formGroup]="parentForm"
      [inputFormatter]="formatInput"
      [ngbTypeahead]="handleTypeahead"
      [placeholder]="placeholder"
      [resultFormatter]="formatResult"
      class="form-control"
      container="body"
      [placement]="placement"
      type="text" />
    <div *ngIf="showButton" class="ms-2">
      <button
        (click)="clickButton()"
        [disabled]="
          typeahead?.disabled ||
          ((!parentForm.dirty || !parentForm.valid) && useFormForButton)
        "
        class="btn btn-primary"
        type="button">
        {{ buttonName }}
      </button>
    </div>
  </div>
  <ng-container
    *ngIf="
      (errorMessage || inputValue.invalid) && inputValue.dirty;
      else label
    ">
    <app-error-label
      [message]="
        errorMessage ? errorMessage : 'Invalid ' + labelName
      "></app-error-label>
  </ng-container>
  <ng-template #label>
    <app-info-label
      *ngIf="description && showDescription"
      [message]="description"></app-info-label>
  </ng-template>
</div>
